export const agGridLicenseKey = process.env.REACT_APP_AG_GRID_LICENSE_KEY || ''

export const DISABLED_DEAL_STATUSES = ['Locked', 'Expired Deal', 'Freeze Deal', 'Invalid deal']
export const ENABLED_DEAL_STATUSES = ['In Progress', 'Unlocked', 'Completed']
